/**
 * Mexican peso.
 */
export var MXN = {
  code: 'MXN',
  base: 10,
  exponent: 2
};